import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { InputWithLabel, Switch } from '@reveni-io/reveni-ui'

import useManufacturerToggle from './hooks/useManufacturerToggle/useManufacturerToggle'

const ManufacturerFields = ({ name, address, onChange }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { isEnabled, handleToggle } = useManufacturerToggle({ name, address, onChange })

  const handleChangeName = e => onChange({ manufacturer_name: e.target.value || null })

  const handleChangeAddress = e => onChange({ manufacturer_address: e.target.value || null })

  return (
    <>
      <Switch checked={isEnabled} onChange={handleToggle} label={t('Añadir nombre y dirección del fabricante')} />
      {isEnabled && (
        <>
          <InputWithLabel
            label={t('Nombre del fabricante')}
            type="text"
            value={name || ''}
            onChange={handleChangeName}
            backgroundColor={theme.colors.background.primary}
            fullWidth
          />
          <InputWithLabel
            label={t('Dirección del fabricante')}
            type="text"
            value={address || ''}
            onChange={handleChangeAddress}
            backgroundColor={theme.colors.background.primary}
            fullWidth
          />
        </>
      )}
    </>
  )
}

export default ManufacturerFields
